import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsHelperText as HelperText } from './src/HelperText.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(HelperText);
export const FsHelperText = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-helper-text.js.map